module.exports = __webpack_public_path__ + "img/business_9.6d31216b.jpg";